// Classes for vertical layout
export const verticalLayoutClasses = {
  root: 'ts-vertical-layout',
  contentWrapper: 'ts-vertical-layout-content-wrapper',
  header: 'ts-vertical-layout-header',
  headerContentWrapper: 'ts-vertical-layout-header-content-wrapper',
  headerContent: 'ts-vertical-layout-header-content',
  content: 'ts-vertical-layout-content'
}

// Classes for blank layout
export const blankLayoutClasses = {
  root: 'ts-blank-layout'
}

// Classes for front layout
export const frontLayoutClasses = {
  root: 'ts-front-layout',
  header: 'ts-front-layout-header',
  headerContentWrapper: 'ts-front-layout-header-content-wrapper',
  headerContent: 'ts-front-layout-header-content',
  content: 'ts-front-layout-content'
}
